import CalendarMonth from '@mui/icons-material/CalendarMonth'
import HubOutlined from '@mui/icons-material/HubOutlined'
import Home from '@mui/icons-material/Home'
import Insights from '@mui/icons-material/Insights'
import Person from '@mui/icons-material/Person'
import {
  SUPPORT_BOOKINGS_VIEW_ROLES,
  SUPPORT_CASE_DISPATCH_ROLES,
  SUPPORT_VC_AUDIT_VIEW_ROLES,
} from '../access/accessMatrix'

export const nav = [
  {
    id: 'Home',
    name: 'Home',
    color: 'linear-gradient(46deg, #223948 0%, #4639a2 100%)',
    icon: Home,
    to: '',
  },
  {
    id: 'practitioner-management',
    name: 'Practitioners & Service Providers',
    color: 'linear-gradient(46deg, rgb(216, 101, 0) 0%, rgb(216, 101, 0) 100%)',
    icon: Person,
    allowedRoles: ['ROLE_THERAPY_SUP_L1', 'ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3', 'ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_SCREENER_ADMIN'],
    to: '/practitioner-management',
  },
  {
    id: 'clinics-hospitals',
    name: 'Clinics & Hospitals',
    color: 'linear-gradient(46deg,rgb(17, 39, 71) 0%,rgb(198, 82, 67) 100%)',
    icon: Person,
    allowedRoles: ['ROLE_CLINIC_SUCCESS_MANAGER', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_ROSTER_MANAGER', 'ROLE_THERAPY_SUP_L3'],
    to: '/clinics-hospitals',
  },
  {
    id: 'overall-roster',
    name: 'Overall Roster',
    color: 'linear-gradient(46deg, rgb(34, 139, 34) 0%, rgb(0, 128, 0) 100%)',
    icon: CalendarMonth,
    allowedRoles: ['ROLE_CLINIC_ROSTER_MANAGER', 'ROLE_CLINIC_ROSTER_ADMIN'],
    to: '/roster-management/overall-roster',
  },
  {
    id: 'booked-events',
    name: 'Bookings & Appointments',
    color: 'linear-gradient(46deg,rgb(0, 152, 186) 0%, rgb(0, 152, 186) 100%)',
    icon: CalendarMonth,
    allowedRoles: [...SUPPORT_BOOKINGS_VIEW_ROLES, ...SUPPORT_VC_AUDIT_VIEW_ROLES],
    to: '/booked-events',
  },
  {
    id: 'case-dispatch',
    name: 'Case Dispatch',
    color: 'linear-gradient(46deg, rgb(9, 105, 128) 0%, rgb(190, 91, 42) 100%)',
    icon: HubOutlined,
    allowedRoles: SUPPORT_CASE_DISPATCH_ROLES,
    to: '/case-dispatch',
  },
  {
    id: 'management-reporting',
    name: 'Management Reporting',
    color: 'linear-gradient(46deg, rgb(18, 93, 152) 0%, rgb(31, 143, 110) 100%)',
    icon: Insights,
    to: '/management-reporting',
    items: [
      {
        id: 'management-reporting-bookings',
        name: 'Bookings',
        to: '/management-reporting/bookings',
        allowedRoles: ['ROLE_MANAGEMENT'],
      },
    ],
  },
  // {
  //   id: 'therapist-roster',
  //   name: 'Therapist Roster',
  //   color: 'linear-gradient(46deg,rgb(206, 92, 26) 0%,rgb(206, 92, 26) 100%)',
  //   icon: CalendarMonth,
  //   allowedRoles: ['ROLE_CLINIC_ROSTER_MANAGER'],
  //   to: '/therapist-roster',
  // },
  {
    id: 'patient-management',
    name: 'Patients',
    color: 'linear-gradient(46deg, rgb(68, 25, 199) 0%, rgb(104, 78, 220) 100%)',
    icon: Person,
    allowedRoles: ['ROLE_THERAPY_SUP_L1', 'ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
    to: '/patient-management',
  },
  // {
  //   id: 'clinic-payout-reports',
  //   name: 'Clinic Payout Reports',
  //   color: 'linear-gradient(46deg, rgb(68, 25, 199) 0%, rgb(104, 78, 220) 100%)',
  //   icon: Person,
  //   allowedRoles: ['ROLE_THERAPY_SUP_L2'],
  //   to: '/clinic-payout-reports',
  // },
  // {
  //   id: 'clinic-engagement-models',
  //   name: 'Clinic Engagement Models',
  //   color: 'linear-gradient(46deg, rgb(68, 25, 199) 0%, rgb(104, 78, 220) 100%)',
  //   icon: Person,
  //   allowedRoles: ['ROLE_THERAPY_SUP_L2'],
  //   to: '/clinic-engagement-models',
  // },

  {
    id: 'doc-side',
    name: 'DocSide',
    color: 'linear-gradient(46deg, rgb(34, 193, 195) 0%, rgb(253, 187, 45) 100%)',
    icon: Person,
    allowedRoles: ['ROLE_DOCSIDE_ADMIN'],
    to: '/doc-side',
  },
  // {
  //   id: 'kyc-approvals',
  //   name: 'KYC Approvals',
  //   color: 'linear-gradient(46deg, rgb(34, 193, 195) 0%, rgb(253, 187, 45) 100%)',
  //   icon: Person,
  //   allowedRoles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
  //   to: '/kyc-approvals',
  // },
  // {
  //   id: 'therapist-roster',
  //   name: 'Therapist Roster',
  //   color: 'linear-gradient(46deg, #223948 0%, #4639a2 100%)',
  //   icon: Person,
  //   allowedRoles: ['ROLE_CLINIC_ROSTER_MANAGER'],
  //   to: '/therapist-roster',
  // },
].sort((a, b) => {
  if (a.name === 'Home') return -1
  if (b.name === 'Home') return 1
  return a.name.localeCompare(b.name)
})

export const _supportNav = (roleArray, excludeHome = false) => {
  const finalNavList = nav
    .filter((navs) => {
      if (navs?.items) {
        return roleArray?.some((role) => {
          return navs?.items?.length === 0
            ? false
            : navs?.items?.some((navItem) => {
                return !!navItem?.allowedRoles && navItem?.allowedRoles?.length > 0
                  ? navItem?.allowedRoles.includes(role)
                  : true
              })
        })
      } else {
        return !navs.allowedRoles || navs.allowedRoles?.length === 0
          ? true
          : roleArray?.some((role) => navs?.allowedRoles?.includes(role))
      }
    })
    .filter((nav) => {
      if (excludeHome) {
        return nav?.to !== ''
      }
      return true
    })
    .map((navs) => {
      if (navs?.items) {
        const navItems = navs.items?.filter((navItem) => {
          return !!navItem?.allowedRoles && navItem?.allowedRoles?.length > 0
            ? navItem?.allowedRoles?.some((navRole) => roleArray.includes(navRole))
            : true
        })
        return { ...navs, items: navItems, to: '/support-home' + navs?.to }
      }
      return { ...navs, to: '/support-home' + navs?.to }
    })
  // console.log({ finalNavList, roleArray })
  return finalNavList
}
